import routingStore from '../stores/routingStore'

// selector: to which id he should scroll
// route, optional: to which route he should jump
// isRedirect, optional: if redirect is given, he should go to state.redirect instead of route,
//    otherwise state.redirect will get passed through

export default async (selector, route, isRedirect) => {
  const redirectWhitelist = ['/category', '/search', '/profile', '/wallet']

  const isOnWhitelist = (redirect) => redirectWhitelist.map(string => redirect.includes(string)).reduce((a, b) => a || b)

  if (route) {
    if(isRedirect && routingStore.history.location.state && isOnWhitelist(routingStore.history.location.state.redirect)) {
      await routingStore.push(routingStore.history.location.state.redirect)
    }
    else {
      await routingStore.history.push(route, routingStore.history.location.state)
    }
  }
  if (selector === 'top') {
    window.scrollTo({
      'behavior': 'smooth',
      'left': 0,
      'top': 0
    })
  } else {
    setTimeout(() => {
      const waitingInterval = setInterval(() => {
        const position = (document.querySelector(selector) && document.querySelector(selector).getBoundingClientRect()) || 0

        window.scrollTo({
          'behavior': 'smooth',
          'left': 0,
          'top': position.top + window.scrollY - 50
        })
        clearInterval(waitingInterval)
      }, 50)
    }, 250)
  }
}



// WEBPACK FOOTER //
// ./src/utils/anchorScroll.js